import React from 'react';
import Grid from '@material-ui/core/Grid';
import classes from './Notification.module.css';
import { getTime,isRecentNotification } from './notificationutils';

class BroadCastNotification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notificationtime: "Just Now",
			isNew : false
		};
	}

	componentDidMount() {
		this.setState({ notificationtime: getTime(this.props.info.createdAt) });
		this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
	}

	render() {
		return (
			<div className={classes.MesGrid}>
				<Grid container direction="row" justify="space-between" alignItems="flex-start" wrap="nowrap">
					<div className={ this.state.isNew ? classes.newNotificationMesHeader : classes.notificationMesHeader}>{this.props.info.title}</div>
					<div className={ this.state.isNew ? classes.newNotificationDateMesHeader:classes.notificationDateMesHeader}>{this.state.notificationtime}</div>
				</Grid>
				<div className={classes.notificationMes}>{this.props.info.message}</div>
				<div className={this.state.isNew ? classes.NewMesDivider : classes.MesDivider} />
			</div>
		);
	}
}

export default BroadCastNotification;
